import { Formik } from "formik";
import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { CreateNotification } from "../../../components/notifier";
import Spinner from "../../../components/spinner/Spinner";
import { FileHelper } from "../../../helper";
import { useSearchParams } from "../../../hook/use-search-params";
import { FileService } from "../../../services/file/file.service";
import UploadFileDragDrop from "./upload-file-drap-drop";

interface AddFileModalProps {
  onClose: () => void;
  onAddFileCompleted: (infoResults: any[]) => void;
  isOpen: boolean;
  validFile: (file: any) => string;
}

const AddFileModal = (props: AddFileModalProps) => {
  const { onClose, onAddFileCompleted, isOpen, validFile } = props;
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const isForbidden = useSelector((state: any) => state.main.isForbidden);
  const { searchParams } = useSearchParams();
  const folderId = searchParams.get("folderId") || "root";

  const handleOnSubmit = () => {
    if (files.length === 0) {
      CreateNotification({
        title: "Thông báo",
        body: `Anh/Chị vui lòng chọn File để tải lên.`,
        icon: "/icons/warning.png",
      });
      return;
    } else {
      setUploading(true);
      try {
        const promises: any[] = [];
        files.forEach((file: any) => {
          // if (validFile(file) === "")

          const newFile = new File([file], FileHelper.createFileName(file.name), {
            type: file.type,
            lastModified: file.lastModified,
          });

          promises.push(FileService.uploadFile(newFile, folderId));
        });

        if (promises.length === 0) {
          setUploading(false);
          onClose();
        }

        Promise.all(promises)
          .then((uploadedFileResults) => {
            if (uploadedFileResults && uploadedFileResults.length > 0) {
              const infoPromises: any[] = [];
              uploadedFileResults.forEach((item) => {
                const mapDataItem = FileService.mapData(item.data);
                infoPromises.push(
                  FileService.createFileDocumentInfo(
                    {
                      ...mapDataItem,
                      name: FileHelper.extractFileName(mapDataItem.name || ""),
                    },
                    folderId,
                  ),
                );
              });
              Promise.all(infoPromises).then((infoResults) => {
                setUploading(false);
                onClose();
                onAddFileCompleted(infoResults);
              });
            }
          })
          .catch(() => {
            handleError();
            setUploading(false);
          });
      } catch (error) {
        handleError();
        setUploading(false);
      }
    }
  };

  const handleError = () => {
    if (isForbidden) {
      CreateNotification({
        title: "Thông báo",
        body: `Bạn không có quyền truy cập tài liệu. Vui lòng liên hệ Admin để hỗ trợ.`,
        icon: "/icons/error.png",
      });
    } else {
      CreateNotification({ title: "Thông báo", body: `Tải tài liệu thất bại.`, icon: "/icons/error.png" });
    }
  };

  const onCompleted = async (values: any) => {
    setFiles(values);
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered size={"lg"} className="add-folder-modal" backdrop="static">
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={{
          documentType: null,
        }}
      >
        {({ handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Spinner show={uploading} />
            <Modal.Header closeButton>
              <Modal.Title>Tải Tài Liệu</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-4 px-4">
              <div className="py-3">
                <UploadFileDragDrop onCompleted={onCompleted} validFile={validFile} />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button disabled={uploading} onClick={onClose} variant="secondary">
                Hủy
              </Button>
              <Button disabled={uploading} type="submit" variant="info">
                {!uploading ? "Tải tài liệu" : "Đang tải tài liệu lên"}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddFileModal;
